/* global axios */
import { msBaseUrl } from './microservicos';

export const specialtiesAPI = {
  getAll(accountId, activeOnly = false) {
    return axios.get(`${msBaseUrl('crm', accountId)}/specialties`, {
      params: { activeOnly },
    });
  },

  create(accountId, data) {
    return axios.post(`${msBaseUrl('crm', accountId)}/specialties`, data);
  },

  update(accountId, id, data) {
    return axios.put(`${msBaseUrl('crm', accountId)}/specialties/${id}`, data);
  },

  delete(accountId, id) {
    return axios.delete(`${msBaseUrl('crm', accountId)}/specialties/${id}`);
  },
};
